import { z } from "zod";
import type { DocumentTypeConfig } from "../types";
import { REMUNERATION_REFERENCE_ALLOWED_MIME_TYPES } from "../../utils/remuneration.constants";

export const CompanyRemunerationReferenceDataSchema = z.object({
  expiration_date: z.string(),
});

export type CompanyRemunerationReferenceData = z.infer<typeof CompanyRemunerationReferenceDataSchema>;

export const CompanyRemunerationReferenceExtractionSchema = z.object({
  expiration_date: z.string(),
});

export type CompanyRemunerationReferenceExtraction = z.infer<typeof CompanyRemunerationReferenceExtractionSchema>;

export const CompanyRemunerationReferenceContextSchema = z.object({
  companyId: z.guid(),
  siren: z.string(),
});

export type CompanyRemunerationReferenceContext = z.infer<typeof CompanyRemunerationReferenceContextSchema>;

type CompanyRemunerationReferenceConfig = DocumentTypeConfig<
  typeof CompanyRemunerationReferenceDataSchema,
  typeof CompanyRemunerationReferenceContextSchema
>;

export const COMPANY_REMUNERATION_REFERENCE_CONFIG: CompanyRemunerationReferenceConfig = {
  documentType: "company_remuneration_reference",
  documentName: "Barème convention collective",
  maxFiles: 1,
  acceptedMimeTypes: REMUNERATION_REFERENCE_ALLOWED_MIME_TYPES,
  dataSchema: CompanyRemunerationReferenceDataSchema,
  contextSchema: CompanyRemunerationReferenceContextSchema,
  requiredFields: ["expiration_date"],
  fieldLabels: {
    expiration_date: "Date d'expiration",
  },
};
